import ResponseHelper from '@/libs/api/response-helper';

export default (axios) => ({
  getUserCertificate(idCode, userName) {
    return axios({
      method: 'get',
      url: `certificates/${idCode}`,
      params: {
        username: userName
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response.data,
          code: 0,
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getResponseError(error));
      });
  },
  getStudentCertificates(utoken) {
    return axios({
      method: 'get',
      url: `certificates`,
      headers: {
        utoken: utoken
      }
    })
      .then(function (response) {
        return Promise.resolve({
          data: response.data,
          code: 0,
          message: 'OK'
        });
      })
      .catch(function (error) {
        return Promise.reject(ResponseHelper.getResponseError(error));
      });
  }
});
